"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Initial Consultation",
  description: "We begin with a detailed discussion to understand your specific goals and project requirements."
}, {
  title: "Strategic Planning",
  description: "Our experts develop a tailored roadmap designed to maximize efficiency and ensure success."
}, {
  title: "Seamless Execution",
  description: "We implement the strategy with precision, keeping you informed at every milestone of the journey."
}, {
  title: "Ongoing Support",
  description: "Our partnership continues with dedicated maintenance and optimization to ensure long-term growth."
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261521" id="how-it-works" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            How It Works
          </h2>
          <p className="text-xl text-muted-foreground font-default">
            Experience a streamlined approach designed for clarity, speed, and exceptional results from start to finish.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {steps.map((step, i) => <Card key={i} data-index={i} className="shadow-lg hover:shadow-xl transition-all duration-300 h-full border-border bg-card rounded-lg">
              <CardHeader className="pb-4">
                <div className="size-12 rounded-lg bg-primary text-primary-foreground flex items-center justify-center text-xl font-bold mb-4 shrink-0 shadow-sm">
                  {i + 1}
                </div>
                <CardTitle className="text-2xl font-default leading-tight text-foreground">
                  {step.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground font-default leading-relaxed">
                  {step.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}